<template>
  <div>
    <van-loading v-if="box.loading" size="24px" vertical class="loading">
      {{ $t("loading") }}...
    </van-loading>

    <div id="charts-wrapper" v-if="!box.loading">
      <section
        id="container-wordviews"
        class="chart-section"
        :style="{
          'min-height': `${getChartMinHeight}`
        }"
      >
        <h2 class="section-title">{{ $t("stats.charttitle wordviews") }}</h2>
        <van-loading
          v-if="word_views.loading"
          size="24px"
          vertical
          class="loading"
        >
          {{ $t("loading") }}...
        </van-loading>
        <BoxWordStatisticsWordviewChart
          v-else-if="Object.keys(word_views.data).length > 0"
          :wordViews="word_views.data"
          :cards="box.data.cards"
        />
        <span class="no-data" v-else>{{
          $t("stats.box wordview data not available")
        }}</span>
      </section>

      <section
        id="container-quizresults"
        class="chart-section"
        :style="{
          'min-height': `${getChartMinHeight}`
        }"
      >
        <h2 class="section-title">{{ $t("stats.charttitle quizwords") }}</h2>
        <van-loading
          v-if="quiz_results.loading"
          size="24px"
          vertical
          class="loading"
        >
          {{ $t("loading") }}...
        </van-loading>

        <BoxWordStatisticsQuizChart
          v-else-if="
            Object.keys(quiz_results.data).length > 0 &&
              Object.keys(quiz_results.data.counts).length > 0
          "
          :quizResults="quiz_results.data"
          :cards="box.data.cards"
        />
        <span class="no-data" v-else>{{
          $t("stats.box quiz data not available")
        }}</span>
      </section>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import BoxWordStatisticsQuizChart from "@/components/chart/BoxWordStatisticsQuizChart";
import BoxWordStatisticsWordviewChart from "@/components/chart/BoxWordStatisticsWordviewChart";
import BarChartCommons from "@/components/chart/BarChartCommons";
export default {
  name: "BoxWordStatisticsCharts",
  components: {
    BoxWordStatisticsQuizChart,
    BoxWordStatisticsWordviewChart
  },
  methods: {
    ...mapMutations("setting", ["SET_PAGE_TITLE"]),
    ...mapActions("statistics", ["fetchQuizStats", "fetchWordViewStats"])
  },
  computed: {
    ...mapState("vokabel", ["box"]),
    ...mapState("account", ["user"]),
    ...mapState("statistics", ["word_views", "quiz_results"]),
    getChartMinHeight: function() {
      if (this.box.data && this.box.data.cards) {
        return BarChartCommons.getChartMinHeight(this.box.data.cards.length);
      }
      return 0;
    },
    loaded: function() {
      return !this.word_views.loading && !this.quiz_results.loading;
    }
  },
  mounted() {
    this.fetchWordViewStats({ box: this.box.data });
    this.fetchQuizStats({ box: this.box.data });
  }
};
</script>

<style lang="scss">
#charts-wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  padding-left: 7px;

  .no-data {
    margin-left: 16px;
    font-size: 0.9rem;
  }

  .chart-section {
    flex: 1 0 50%;
    padding: 5px 10px;
    min-width: 210px;

    display: flex;
    flex-direction: column;

    .chart-container {
      position: relative;
      flex: 1;
    }
  }
}
</style>
